import { render, staticRenderFns } from "./VersionUpdateDialog.vue?vue&type=template&id=8ccc793c&scoped=true"
import script from "./VersionUpdateDialog.vue?vue&type=script&lang=js"
export * from "./VersionUpdateDialog.vue?vue&type=script&lang=js"
import style0 from "./VersionUpdateDialog.vue?vue&type=style&index=0&id=8ccc793c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccc793c",
  null
  
)

export default component.exports